module.exports = __webpack_public_path__ + "img/icon_square-v.2c8554cc.svg";